<template>
    <data-table
        :id="state_identifier"
        :columns="visible_columns"
        :rows="filtered_rows"
        :search="state.search"
        :total="state.total"
        :found="state.found"
        :current-page="state.page"
        :total-pages="nb_pages"
        :searchable="false"
        table-class="uk-table-condensed uk-table-hover lam-subrecords-list"
        empty-title="No billing scheduled..."
        @sort="sort_by"
        @search="search"
        @page="goto_page"
        @click="record_edit('project', $event.project_id)"
    >
        <template
            v-slot:controls
        >
            <div class="lam-list-filters">
                <ul slot="filters" class="uk-tab lam-filters">
                    <li :class="{'uk-active': !state.filter}">
                        <a href @click.prevent="filter('status', '')">Not Billed</a>
                    </li>
                    <li :class="{'uk-active': state.filter==='billed'}">
                        <a href @click.prevent="filter('status', 'billed')">Billed</a>
                    </li>
                </ul>
            </div>
        </template>
        <template
            v-slot:summary="{ row }"
        >
            <h6>{{ row.project_name }}</h6>
        </template>
        <template
            v-slot:tbody="{ row, field }"
        >
            <form-checkbox
                v-if="field === 'billed_at_as_string'"
                :id="`billing-schedule-month-${row.id}-billed_at`"
                :value="!!row.billed_at_as_string"
                name="billed_at"
                @input="save_field_for_record_id('billing_schedule_month', row.id, $event ? $moment().format('YYYY-MM-DD HH:mm:ss') : null, 'billed_at')"
            />
            <router-link
                v-else-if="field === 'project_name'"
                :to="{ name: 'project.edit', params: { id: row.project_id } }"
            >
                {{ row.project_name }}
            </router-link>
            <span v-else-if="field === 'amount'">${{ row.amount | nibnut.number("0,0.00") }}</span>
            <span v-else>{{ row[field] }}</span>
       </template>
    </data-table>
</template>

<script type="text/javascript">
import dashboard_card from "./dashboard_card"
import is_remote_data_table_source from "../../mixins/IsRemoteDataTableSource"
import project_utilities from "../../mixins/ProjectUtilities"
import handles_saving from "../../mixins/HandlesSaving"

import FormCheckbox from "../../ui/FormCheckbox"

export default {
    mixins: [dashboard_card, is_remote_data_table_source, project_utilities, handles_saving],
    components: {
        FormCheckbox
    },
    methods: {
        filter_rows (rows) {
            if(this.state.filter_on) {
                return rows.filter(row => {
                    if(this.state.filter === "billed") return !!row.billed_at_as_string
                    return !row.billed_at_as_string
                })
            }
            return rows
        }
    },
    computed: {
        state_identifier () {
            return `Dashboard-${this.card.type}`
        },
        visible_columns () {
            return {
                billed_at_as_string: this.columns.billed_at_as_string,
                project_name: this.columns.project_name,
                amount: this.columns.amount
            }
        }
    },
    data () {
        return {
            entity: "billing_schedule_month",
            columns: {
                billed_at_as_string: { label: "Billed", sort: false, type: "plain", cell_class: "uk-width-1-10" },
                project_name: { label: "Project", sort: false, type: "plain" },
                amount: { label: "Amount", sort: "desc", type: "plain", cell_class: "uk-width-3-10" },
                project_id: { label: "Project ID", sort: false, type: "plain" }
            },

            default_state: {
                per_page: 5,
                page: 1,
                sort_by: "amount",
                sort_dir: "desc",
                filter_on: "status",
                filter: "",
                archived: false,
                search: "",
                total: 0,
                found: 0,
                context: "dashboard",
                activated_at: 0
            }
        }
    }
}
</script>
